import Vue from "vue";
import VueRouter from "vue-router";
import { hasLogined, completeAccountInfo } from "../api/api";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/Home.vue"),
    beforeEnter: (to, from, next) => {
      hasLogined().then(res=> {
        if(res) {
          completeAccountInfo().then( res=> {
            if (res.needMobile || res.needScanCode || res.needUsername) {
              next('/completeInfo')
            } else {
              next()
            }
          })
        } else {
          next('/login')
        }
      })
    }
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
    beforeEnter: (to, from, next) => {
      if (to.query.error_type != undefined) {
        // console.log(to.query.error_type)
        next();
      } else {
        hasLogined().then((res) => {
          // console.log(res)
          if (res) {
            next("/home");
          } else {
            next();
          }
        });
      }
    },
  },
  {
    path: "/forgetPwd",
    name: "ForgetPwd",
    component: () => import("../views/ForgetPwd.vue"),
  },
  {
    path: "/completeInfo",
    name: "CompleteInfo",
    component: () => import("../views/CompleteInfo.vue"),
    beforeEnter: (to, from, next) => {
      completeAccountInfo().then( res=> {
        if (res.needMobile || res.needScanCode || res.needUsername) {
          next()
        } else {
          next('/')
        }
      })
    }
  },
  {
    path: "/accountSecurity",
    name: "AccountSecurity",
    component: () => import("../views/AccountSecurity.vue"),
  },
  {
    path: "/invite/register",
    name: "register",
    component: () => import("../views/inviteRegister.vue"),
  },
];

const router = new VueRouter({
  // mode: "history",
  routes,
});

export default router;
